export function initialize(appInstance) {
  let ajax = appInstance.lookup("service:ajax")
}

export default {
  name: "ajax",
  initialize: initialize,
  after: ["session"],
}
